/// <reference types="datatables.net" />

import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiIntegration } from "../../_services/api.integration";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { User } from "../../_models/user";
import { Router } from "@angular/router";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { Globals } from "../../_models/globals";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-create-address',
  templateUrl: './create-address.component.html',
  styleUrls: ['./create-address.component.css']
})
export class CreateAddressComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  addressTypes: any = [];
  address1: string;
  address2: string;
  addressType: string = 'SHIPPING';
  city: string;
  state: string;
  zip: string;
  geoCode: string;
  statusText1: string;
  statusText2: string;
  statusText3: string;
  statusText4: string;
  statusText5: string;
  statusText6: string;
  statusText7: string;
  statesList: any;
  citiesList: any;

  constructor(private alertService: AlertService, private api: ApiIntegration, private http: HttpClient, private user: User, private router: Router, public g: Globals) {
    this.g.page = "Create Address";
    this.api.getValues("1", "ADDRESS_TYPE", "ADDRESS_TYPE", "ADDRESS_TYPE").subscribe((data: any) => {

      this.addressTypes = data.tripleSetConfigDTOS;
    }, err => {
      this.alertService.error('Error', err);
    });
    this.stateList();
    this.cityList();
  }

  stateList() {
    this.api.getDistinctStates().subscribe((data: any) => {
      this.statesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  cityList() {
    this.api.getDistinctCity().subscribe((data: any) => {
      this.citiesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  changeCityAndState() {
    this.api.getCityAndStateByPinCode(this.zip).subscribe((data: any) => {
      this.city = data.city;
      this.state = data.state;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      lengthMenu: [10, 50, 100],
      pageLength: 10
    };
  }

  selectAddressType() {
    this.statusText6 = "";
    if (this.addressType == '' || this.addressType === null || this.addressType === undefined || this.addressType === 'undefined') {
      this.statusText6 = 'Please select addressType';
    }
  }

  typeAddress1() {
    this.statusText1 = "";
    if (this.address1 == '' || this.address1 === null || this.address1 === undefined || this.address1 === 'undefined') {
      this.statusText1 = 'Please enter address';
    }
  }

  typeCity() {
    this.statusText3 = "";
    if (this.city == '' || this.city === null || this.city === undefined || this.city === 'undefined') {
      this.statusText3 = 'Please enter city';
    }
  }

  typeState() {
    this.statusText4 = "";
    if (this.state == '' || this.state === null || this.state === undefined || this.state === 'undefined') {
      this.statusText4 = 'Please enter state';
    }
  }

  typeZip() {
    this.statusText5 = "";
    if (this.zip == '' || this.zip === null || this.zip === undefined || this.zip === 'undefined') {
      this.statusText5 = 'Please enter zip';
    } else if (this.zip.length != 6) {
      this.statusText5 = 'ZipCode must be minimum 6 characters';
    }
  }


  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {

    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.destroy();

      this.dtTrigger.next(true);
    });
  }

  createAddress() {
    this.g.loaderDisplay = "display";
    this.statusText1 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";
    this.statusText6 = "";

    if (this.address1 == '' || this.address1 === null || this.address1 === undefined || this.address1 === 'undefined') {
      this.statusText1 = 'Please enter address';
    }

    if (this.city == '' || this.city === null || this.city === undefined || this.city === 'undefined') {
      this.statusText3 = 'Please enter city';
    }
    if (this.state == '' || this.state === null || this.state === undefined || this.state === 'undefined') {
      this.statusText4 = 'Please enter state';
    }
    if (this.zip == '' || this.zip === null || this.zip === undefined || this.zip === 'undefined') {
      this.statusText5 = 'Please enter zip';
    } else if (this.zip.length != 6) {
      this.statusText5 = 'ZipCode must be minimum 6 characters';
    }
    if (this.addressType == '' || this.addressType === null || this.addressType === undefined || this.addressType === 'undefined') {
      this.statusText6 = 'Please select addressType';
    }

    if (this.statusText1 != "" || this.statusText3 != "" || this.statusText4 != "" || this.statusText5 != "" || this.statusText6 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createAddress', {
      "accountOwnerId": this.user.accountOwnerId,
      "address1": this.address1,
      "address2": this.address2,
      "addressType": "SHIPPING",
      "city": this.city,
      "organizationId": 1,
      "state": this.state,
      "status": "ACTIVE",
      "zip": this.zip,
      "geoCode": this.geoCode
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Address', 'Created Successfully');
          this.router.navigate(['/admin/myAccountList']);
        } else if (data['code'] == 400) {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }
}
